var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPanelExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.963,
    height: 14.963,
    viewBox: "0 0 14.963 14.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_panel_expand_RAJA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619,9.92H10.79a1.572,1.572,0,0,0-1.567,1.568V23.316a1.572,1.572,0,0,0,1.567,1.568H22.619a1.572,1.572,0,0,0,1.567-1.568V11.488A1.572,1.572,0,0,0,22.619,9.92Zm-.1,11.729a1.572,1.572,0,0,1-1.568,1.567H12.458a1.572,1.572,0,0,1-1.568-1.567V13.155a1.572,1.572,0,0,1,1.568-1.567h8.493a1.572,1.572,0,0,1,1.568,1.567Z",
    transform: "translate(-9.223 -9.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPanelExpand);
export default __webpack_public_path__ + "static/media/Icon_panel_expand.37e2c6270143fa93568be3e06187a895.svg";
export { ForwardRef as ReactComponent };